module.exports = __webpack_public_path__ + "static/img24-3b68418c4d089d31b28795580dc68930.jpg";